import type { ReactNode } from "react";

interface MSOWrapperProps {
  children: ReactNode;
  endComment: string;
  startComment: string;
}

export const MSOWrapper = ({
  children,
  startComment,
  endComment,
}: MSOWrapperProps) => (
  <>
    <div dangerouslySetInnerHTML={{ __html: startComment }} />
    {children}
    <div dangerouslySetInnerHTML={{ __html: endComment }} />
  </>
);
